import { HStack, Select, Text } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { PositionSort } from '../types';
import { useStoreActions, useStoreState } from '../../../../../models/hooks';

function SortPositionComponent() {
  const { t } = useTranslation('moniterByRecruiters');

  const { positionFilters } = useStoreState((store) => store.moniterByRecruiters);
  const { setPositionFilter } = useStoreActions((store) => store.moniterByRecruiters);

  return (
    <HStack spacing={2}>
      <Text whiteSpace="nowrap" fontSize="sm" fontWeight="normal" textColor="gray[500]">
        {t('positions.tableHeader.sort.label')}
      </Text>
      <Select
        variant="unstyled"
        width="fit-content"
        fontWeight="bold"
        fontSize="sm"
        value={positionFilters.sortBy}
        height="1rem"
        onChange={(e) => {
          const selected = e.target.value as PositionSort;
          setPositionFilter({ key: 'sortBy', value: selected });
        }}
      >
        {(Object.keys(PositionSort) as (keyof typeof PositionSort)[])?.map((option) => {
          return (
            <option key={option} value={PositionSort[option]}>
              {t(`positions.tableHeader.sort.options.${option}`)}
            </option>
          );
        })}
      </Select>
    </HStack>
  );
}

export const SortPosition = React.memo(SortPositionComponent);
